import { htmlToPlainText } from "@/modules/plainText";
import {
  CHAIN_META,
  CHAIN_META_DESC,
  CHAIN_META_TAG,
  CHAIN_META_TAGS,
} from "@/components/shopwindow/chainMetaClasses";
import type { ChainRecommendation } from "@/types/experience";

// Tag chips shown before truncating; a long ingredient list would balloon the card.
const MAX_TAGS = 6;

type ChainCardMetaProps = {
  item?: ChainRecommendation | null;
};

/**
 * The optional description and tag chips shared by the Up Next list cards and
 * the next-video block. Categorical tags (cuisine, occasion, meal) come first,
 * then ingredients. Renders nothing when the item has neither.
 */
export default function ChainCardMeta({ item }: ChainCardMetaProps) {
  // Descriptions arrive as HTML; show them as plain text.
  const description =
    item && item.description ? htmlToPlainText(item.description) : null;
  const tags = ([] as string[])
    .concat((item && item.cuisine) || [])
    .concat((item && item.occasion) || [])
    .concat((item && item.meal) || [])
    .concat((item && item.ingredients) || [])
    .filter(Boolean);

  if (!description && tags.length === 0) {
    return null;
  }

  return (
    <span className={`chain-meta ${CHAIN_META}`}>
      {description ? (
        <span className={`chain-meta__desc ${CHAIN_META_DESC}`}>
          {description}
        </span>
      ) : null}
      {tags.length ? (
        <span className={`chain-meta__tags ${CHAIN_META_TAGS}`}>
          {tags.slice(0, MAX_TAGS).map((tag, index) => (
            <span
              key={tag + index}
              className={`chain-meta__tag ${CHAIN_META_TAG}`}
            >
              {tag}
            </span>
          ))}
        </span>
      ) : null}
    </span>
  );
}
